


















































































import { Component, Vue, Watch, PropSync, Prop } from "vue-property-decorator";
import { tiposEndereco } from "@/models/cadastros/assistencia/TipoEndereco";
import { estadosList } from "@/models/cadastros/assistencia/Estados";
import { ValidationObserver } from "vee-validate";
import ServicoSubClienteModel  from '@/models/cadastros/assistencia/ServicoSubClienteModel';

@Component
export default class ServicoSubCliente extends Vue {
  estados = estadosList;
  tiposEnderecos = tiposEndereco;

  $refs!: {
    servicoSubClienteObserver: InstanceType<typeof ValidationObserver>;
  };

  loadingEndereco = false;
  pesquisarAlteracao = false;

  servicoSubCliente: ServicoSubClienteModel = {
      nomeSubCliente: "",
      cpfCnpj: "",
      email: "",
      telefone: "",
      cep: "",
      tipoEndereco: { valor: "", descricao: "" },
      logradouro: "",
      numero: "",
      complemento: "",
      bairro: "",
      cidade: "",
      estado: undefined,
  };

  @Prop({ type: String, default: "" })
  title!: string;

  @PropSync("servicoSubClienteFrota")
  dadosSubCliente!: ServicoSubClienteModel;

}
